(function() {
  const isHeic = (f) => !f ? false : /\.(heic|heif)$/i.test((f.name || '')) || (f.type || '').toLowerCase().includes('heic');

  const CROPPER_OPTS = {
    aspectRatio: 1, viewMode: 2, dragMode: 'move', autoCropArea: 0.8,
    restore: false, guides: true, center: true, highlight: false,
    cropBoxMovable: true, cropBoxResizable: true, toggleDragModeOnDblclick: false,
    zoomable: true, zoomOnWheel: true
  };

  const ZOOM_STEP = 10;

  window.ProfileImageCrop = {
    isHeic,
    processFile(file, done, onErr) {
      const fn = (typeof heic2any === 'function') ? heic2any : window?.heic2any;
      if (isHeic(file) && fn) {
        fn({ blob: file, toType: 'image/jpeg', quality: 0.9 })
          .then(blob => {
            const b = Array.isArray(blob) ? blob[0] : blob;
            if (!b) { onErr?.(); return; }
            const r = new FileReader(); r.onload = () => done(r.result); r.readAsDataURL(b);
          })
          .catch(() => onErr?.());
      } else if (file?.type?.startsWith('image/') || isHeic(file)) {
        const r = new FileReader(); r.onload = () => done(r.result); r.onerror = () => onErr?.(); r.readAsDataURL(file);
      }
    },
    open(els, onApply) {
      const { modal, img, zoom, zoomOut, zoomIn, rotate, cancel, apply } = els;
      if (!modal || !img || typeof Cropper === 'undefined') return null;

      let cropper = null;
      let zoomMin = 0.5, zoomMax = 3;

      const close = () => {
        if (modal) { modal.classList.remove('is-open'); modal.classList.add('is-hidden'); document.body.style.overflow = ''; }
        if (cropper) { cropper.destroy(); cropper = null; }
        if (img) img.src = '';
      };

      const applyCrop = () => {
        if (!cropper) return;
        const canvas = cropper.getCroppedCanvas({ width: 400, height: 400, imageSmoothingEnabled: true, imageSmoothingQuality: 'high' });
        if (!canvas) return;
        close();
        onApply?.(canvas.toDataURL('image/jpeg', 0.95));
      };

      const syncZoom = () => {
        const d = cropper?.getImageData?.();
        if (!d?.naturalWidth || zoomMax <= zoomMin) return;
        const r = d.width / d.naturalWidth;
        zoom.value = Math.round(Math.max(0, Math.min(100, ((r - zoomMin) / (zoomMax - zoomMin)) * 100)));
      };

      const zoomToPct = (pct) => {
        if (!cropper?.zoomTo) return;
        cropper.zoomTo(zoomMin + (zoomMax - zoomMin) * (Math.max(0, Math.min(100, pct)) / 100));
      };

      const openWithSrc = (src) => {
        if (modal.parentNode !== document.body) {
          document.body.appendChild(modal);
          modal.classList.add('is-in-body');
        }
        modal.classList.remove('is-hidden');
        modal.classList.add('is-open');
        document.body.style.overflow = 'hidden';
        img.src = src;

        const init = () => {
          if (cropper) { cropper.destroy(); cropper = null; }
          const opts = { ...CROPPER_OPTS };
          if (zoom) {
            opts.ready = () => {
              setTimeout(() => {
                const d = cropper?.getImageData?.();
                if (d?.naturalWidth) {
                  zoomMin = Math.max(0.1, d.width / d.naturalWidth);
                  zoomMax = Math.max(zoomMin * 3, zoomMin + 1);
                  zoom.value = Math.round(Math.max(0, Math.min(100, ((d.width / d.naturalWidth - zoomMin) / (zoomMax - zoomMin)) * 100)));
                }
              }, 0);
            };
          }
          cropper = new Cropper(img, opts);
          if (zoom) {
            if (typeof cropper.on === 'function') cropper.on('zoom', syncZoom);
            zoom.oninput = () => zoomToPct(parseInt(zoom.value, 10));
            if (zoomOut) zoomOut.onclick = () => { const v = Math.max(0, parseInt(zoom.value, 10) - ZOOM_STEP); zoom.value = v; zoomToPct(v); };
            if (zoomIn) zoomIn.onclick = () => { const v = Math.min(100, parseInt(zoom.value, 10) + ZOOM_STEP); zoom.value = v; zoomToPct(v); };
          }
          if (rotate) rotate.onclick = () => cropper?.rotate(90);
          if (cancel) cancel.onclick = close;
          if (apply) apply.onclick = applyCrop;
        };
        img.complete ? init() : (img.onload = init);
      };

      return { openWithSrc, close };
    }
  };
})();
